import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../environments/environment';
import Pusher from 'pusher-js';
import { HttpHeaders } from '@angular/common/http';
import { SecureStorageService } from './secure-storage.service';

@Injectable({
  providedIn: 'root'
})
export class PusherService {
  private pusher: Pusher | null = null;
  private channels: Map<string, any> = new Map();
  private token: string = '';
  private httpOptions: { headers: HttpHeaders } = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': ''
    })
  };

  constructor(
    private secureStorage: SecureStorageService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    if (!isPlatformBrowser(this.platformId)) return;

    this.token = this.secureStorage.getItem<string>('token') || '';
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.token}`
      })
    };

    this.pusher = new Pusher(environment.pusher.key, {
      cluster: environment.pusher.cluster,
      wsHost: environment.pusher.wsHost,
      wsPort: environment.pusher.wsPort,
      wssPort: environment.pusher.wssPort,
      forceTLS: true,
      disableStats: true,
      enabledTransports: ['ws', 'wss'],
      authEndpoint: environment.pusher.authEndpoint,
      auth: {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      }
    });

    console.log('Pusher initialisé avec la clé:', environment.pusher.key);
  }
  
  // S'abonner à un canal
  subscribeToChannel(channelName: string): void {
    if (!this.pusher || this.channels.has(channelName)) {
      return;
    }

    try {
      console.log(`Abonnement au canal: ${channelName}`);
      const channel = this.pusher.subscribe(channelName);
      this.channels.set(channelName, channel);
      
      channel.bind('pusher:subscription_succeeded', () => {
        console.log(`Abonnement réussi au canal: ${channelName}`);
      });
      
      channel.bind('pusher:subscription_error', (error: any) => {
        console.error(`Erreur d'abonnement au canal ${channelName}:`, error);
      });
    } catch (error) {
      console.error(`Erreur lors de l'abonnement au canal ${channelName}:`, error);
    }
  }
  
  // Se désabonner d'un canal
  unsubscribeFromChannel(channelName: string): void {
    if (this.pusher && this.channels.has(channelName)) {
      console.log(`Désabonnement du canal: ${channelName}`);
      this.pusher.unsubscribe(channelName);
      this.channels.delete(channelName);
    }
  }
  
  // Lier un événement à un canal
  bindEvent(channelName: string, eventName: string, callback: (data: any) => void): void {
    const channel = this.channels.get(channelName);
    if (channel) {
      console.log(`Liaison de l'événement ${eventName} au canal ${channelName}`);
      channel.bind(eventName, callback);
    } else {
      console.error(`Canal ${channelName} non trouvé pour lier l'événement ${eventName}`);
    }
  }
  
  // Déclencher un événement sur un canal
  triggerEvent(channelName: string, eventName: string, data: any): void {
    const channel = this.channels.get(channelName);
    if (channel) {
      console.log(`Déclenchement de l'événement ${eventName} sur le canal ${channelName}`);
      channel.trigger(eventName, data);
    } else {
      console.error(`Canal ${channelName} non trouvé pour déclencher l'événement ${eventName}`);
    }
  }
  
  // Déconnecter Pusher
  disconnect(): void {
    if (this.pusher) {
      console.log('Déconnexion de Pusher');
      this.pusher.disconnect();
    }
  }
} 